<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">{{pageTexts.pageHeaderText}}</h3>
          </div>
          <div>
            <div
              class="m-dropdown m-dropdown--inline m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push"
              m-dropdown-toggle="hover"
              aria-expanded="true"
            >
              <a
                href="#"
                class="m-portlet__nav-link btn btn-lg btn-secondary m-btn m-btn--outline-2x m-btn--air m-btn--icon m-btn--icon-only m-btn--pill m-dropdown__toggle"
              >
                <i class="la la-plus m--hide"></i>
                <i class="la la-ellipsis-h"></i>
              </a>
              <div class="m-dropdown__wrapper" style="z-index: 101;">
                <span
                  class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"
                  style="left: auto; right: 21.5px;"
                ></span>
                <div class="m-dropdown__inner">
                  <div class="m-dropdown__body">
                    <div class="m-dropdown__content">
                      <ul class="m-nav">
                        <li class="m-nav__section m-nav__section--first m--hide">
                          <span class="m-nav__section-text">Quick Actions</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->
          <div class="m-portlet">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <span class="m-portlet__head-icon m--hide">
                    <i class="la la-gear"></i>
                  </span>
                  <h3 class="m-portlet__head-text">
                    <a
                      :href="'#/licenseBundles'"
                      class="btn btn-sm btn-secondary m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill m--margin-right-10"
                    >
                      <i class="la la-angle-left"></i>
                    </a>
                    {{pageTexts.addButtonText}}
                  </h3>
                </div>
              </div>
            </div>

            <!--begin::Form-->
            <form class="m-form m-form--fit m-form--label-align-right">
              <div class="m-portlet__body m-form-box-cont">
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Lisans paketi Kodu</label>
                    <input type="text"  :class="{ 'is-invalid': $v.item.code.$error }" v-model="item.code" class="form-control m-input" placeholder="Lisans kodunu giriniz." />
                  </div>
                </div>
                                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Lisans paketi Adı</label>
                    <input type="text"  :class="{ 'is-invalid': $v.item.name.$error }" v-model="item.name" class="form-control m-input" placeholder="Lisans paketi adını giriniz." />
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Açıklama</label>
                    <textarea  :class="{ 'is-invalid': $v.item.description.$error }" class="form-control m-input" v-model="item.description" placeholder="Lisans açıklamasını giriniz." id="exampleTextarea" rows="3"></textarea>
                  </div>
                </div>
              </div>
              <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                <div class="m-form__actions m-form__actions--solid">
                  <div class="row">
                    <div class="col-lg-12">
                      <button type="button" @click="item.id==0?create():update()" class="spbtn">Kaydet</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <!--end::Form-->
          </div>

          <!--end::Portlet-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import {_create,_getById,_update} from '../../services/LicenseBundleService'

export default {
created() {
  if(Number(this.$route.params.id)!=0)
        {
          this.item.id=Number(this.$route.params.id);
              this.getById();
        }
},

  data() {
    return {
       pageTexts:{
        pageHeaderText: "Lisans Paketi",
        addButtonText:"Lisans Paketi Ekle",
        addEditRedirectPath:"licensebundle"},
      item:{
        id:0,
        code:'',
        name:'',
        description:'',
      }
    }
  },
    validations: {
    item: {
      code: { required },
      name: { required },
           description: { required }
    }
  },
methods: {
  create:function(){
          this.$v.item.$touch();
      if (this.$v.item.$error) return;
          // let loader=this.$loading.show();
    _create(this.item).then(response=>{
      // loader.hide();
      if(response.data.success)
        this.$router.push({ name: 'licenseBundles' })
    });
  },
  update:function(){
          this.$v.item.$touch();
      if (this.$v.item.$error) return;
    _update(this.item).then(response=>{
      if(response.data.success)
        this.$router.push({ name: 'licenseBundles' })
    });
  },
  getById:function(){
    _getById(Number(this.$route.params.id)).then(response=>{
      if(response.data.success)
      this.item=response.data.data;
      else
      this.$router.push({ name: 'licenseBundles' })
    })
  }
},
};
</script>